import React, { createContext, useState, useEffect } from 'react';
import api from '../services/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    console.log('AuthProvider mounted, checking token...');
    const storedToken = localStorage.getItem('token');
    const storedUser = localStorage.getItem('user');
    
    if (storedToken && storedUser) {
      console.log('Token found:', storedToken.substring(0, 20) + '...');
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
    } else {
      console.log('No token found');
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      console.log('Login attempt:', email);
      const response = await api.post('/auth/login', { email, password });
      const { token, user_id, role } = response.data;
      
      const userData = { email, user_id, role };
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(userData));
      
      setToken(token);
      setUser(userData);
      setError('');
      
      console.log('Login success');
      return { success: true };
    } catch (err) {
      const errMsg = err.response?.data?.error || 'Login failed';
      console.error('Login error:', errMsg);
      setError(errMsg);
      return { success: false, error: errMsg };
    }
  };

  const logout = () => {
    console.log('Logout');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, error, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
